<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";

export default {
  page: {
    title: "Alarm Efficiency",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "Alarm Efficiency",
      items: [
        {
          text: "Home",
        },
         {
          text: "Forecast",
        },
        {
          text: "Alarm Efficiency",
          active: true,
        },
      ],
    };
  },
  components: {
    Layout,
    PageHeader,
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  </Layout>
</template>